import React from 'react'
import { useTranslation } from 'react-i18next'
import { useRegistration } from 'pages/AccountView/hooks/useRegistration'
import { AccountFormWrapper, Form, Text } from 'pages/AccountView/components/TextElements'
import { SuccessAnimation } from 'app-view/components/SuccessAnimation'
import { LargeGreenButton } from 'pages/AccountView/components/LargeButtons'
import { useNavigate } from 'react-router-dom'

export const MigrateDeviceSuccess: React.FC = () => {
  const { t } = useTranslation(['account', 'global'])
  const navigate = useNavigate()
  const [{ account }] = useRegistration()

  return (
    <Form>
      <AccountFormWrapper>
        <Text
          dangerouslySetInnerHTML={{
            __html: t('migrate_device_success_description', { account }),
          }}
        />
        <SuccessAnimation />
      </AccountFormWrapper>
      <LargeGreenButton type="button" onClick={() => navigate('/', { replace: true })}>
        {t('global:ok')}
      </LargeGreenButton>
    </Form>
  )
}
